/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

import { Card } from 'primereact/card'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Paginator } from 'primereact/paginator'
import warning from '../assets/images/warning.svg'

import back from '../assets/images/back.svg'
import { Dialog } from 'primereact/dialog'
import { userActions } from '../_actions'

export default function ManageSectorComponent({ currentPage, sectorList, getSectorByPage, deleteSector, totalRecords, clearSectorFilter, isSectorLoading, clearAllIndustryMessages }) {
  const [sectorData, setSectorData] = useState([])
  const [search, setSearch] = useState('')
  const [first, setFirst] = useState(currentPage ? currentPage : 0)
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false)
  const [pageSize] = useState(20)
  const [deleteRow, setDeleteRow] = useState({})
  const [clearFilterRow, setClearFilterRow] = useState({})
  const history = useHistory()
  const [isClearFilterDialogVisible, setIsClearFilterDialogVisible] = useState(false)
  const sectorArray = []
  useEffect(() => {
    for (let i = 0; i < sectorList.length; i++) {
      const sector = sectorList[i]
      sectorArray.push({ 'sectorname': sector.name, 'sequence': sector.sequence, 'year': sector.year, 'industry': sector.industryCount > 0 ? <a href={'/dashboard/industry-list/' + sector.sectorId}> {sector.industryCount} </a> : sector.industryCount, 'company': sector.companyCount > 0 ? <a href={'/dashboard/company-list/sector/' + sector.sectorId}>{sector.companyCount}</a> : sector.companyCount, 'showgrade': sector.showGrade, 'sectorId': sector.sectorId, 'action': '', 'status': sector.isActive })
    }
    setSectorData(sectorArray)
  }, [sectorList])

  useEffect(() => {
    if (search === '') {
      searchByName()
    }
  }, [search])
  const onSearchChange = (e) => {
    const { value } = e.target
    setSearch(value)
  }
  const cols = [
    { field: 'sectorname', header: 'SECTOR NAME' },
    { field: 'sequence', header: ' SEQUENCE' },
    { field: 'year', header: 'YEAR' },
    { field: 'industry', header: 'INDUSTRIES' },
    { field: 'company', header: 'COMPANIES' },
    { field: 'action', header: 'ACTION' }
  ]

  const editSector = (id) => {
    history.push({
      pathname: '/dashboard/edit-sector/' + id
    })
  }
  const editIndustry = (id) => {
    clearAllIndustryMessages()
    history.push({
      pathname: '/dashboard/add-industry/' + id
    })
  }

  const actionTemplate = (rowData) => {
    return <div className="flex">
      <i className="pi pi-plus-circle m-r-5 pointer" title="Add Industry" onClick={() => { editIndustry(rowData.sectorId) }}></i>
      <i className="pi pi-pencil m-r-5 pointer" title="Edit Sector" onClick={() => { editSector(rowData.sectorId) }}></i>
      <i className="pi pi-trash m-r-5 pointer" title="Delete" onClick={(event) => showDeleteDialog(event, rowData)}></i>
      <i className="pi pi-filter pointer  m-r-5" title="Clear Filter" onClick={(event) => showClearFiltersDialog(event, rowData)}></i>
    </div>
  }

  const onPageChange = (event) => {
    setFirst(event.first)
    getSectorByPage(event.page, pageSize, search, '')
  }

  const BackClick = () => {
    history.goBack()
  }

  const dynamicColumns = cols.map((col, i) => {
    if (col.field === 'action') {
      return <Column key={'key-' + i} body={actionTemplate} style={{ textAlign: 'center', width: '8em' }} header={col.header} />
    }
    if (col.field === 'sectorname')
      return <Column key={'key' + i} field={col.field} header={col.header} />
    return <Column key={'key' + i} field={col.field} header={col.header} style={{ textAlign: 'right', width: '8em' }} />
  })

  const onEnterKeySearch = (event) => {

    var code = (event.keyCode ? event.keyCode : event.which)
    if (code === 13) {
      searchByName()

    }
  }
  const searchByName = () => {
    setFirst(0)
    getSectorByPage(0, pageSize, search, '')
  }
  const showDeleteDialog = (event, rowData) => {
    setDeleteRow(rowData)
    setIsDeleteDialogVisible(true)
  }
  const deleteSectorById = () => {
    setFirst(1)
    deleteSector(deleteRow.sectorId, userActions.getCurrentUser())
    setIsDeleteDialogVisible(false)
  }
  const footer = (
    <div>
      <Button label="OK" icon="pi pi-check" onClick={() => deleteSectorById()} />
      <Button label="Cancel" className="p-button-raised p-button-secondary" icon="pi pi-times" onClick={() => setIsDeleteDialogVisible(false)} />
    </div>
  )
  const footerClearFilter = (
    <div>
      <Button label="OK" icon="pi pi-check" onClick={() => clearFiltersById()} />
      <Button label="Cancel" className="p-button-raised p-button-secondary" icon="pi pi-times" onClick={() => setIsClearFilterDialogVisible(false)} />
    </div>
  )
  function AddNewSectorClick() {
    history.push('/dashboard/add-sector')
  }
  const showClearFiltersDialog = (event, rowData) => {
    setClearFilterRow(rowData)
    setIsClearFilterDialogVisible(true)
  }
  const clearFiltersById = () => {
    clearSectorFilter(clearFilterRow.sectorId)
    setIsClearFilterDialogVisible(false)
  }

  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase addSector">
          <div className="titleCon m-b-20">
            <p className="title flex">
              <img src={back} alt={back} className="m-r-10 pointer" onClick={() => BackClick()} />MANAGE STOCK SECTORS
            </p>
            <div className="flex">
              <div className="customBtnContainer m-r-20">
                {totalRecords > 0 && <div className="pointer m-r-10" >{totalRecords} records found</div>}

                <Button icon="pi pi-plus" onClick={AddNewSectorClick} className="addBtnCustom" />
                <div className="pointer" onClick={AddNewSectorClick}>Add New Sector</div>
              </div>
              <div className="p-inputgroup customSearch">
                <InputText placeholder="Search" value={search} onChange={onSearchChange} onKeyUp={(e) => onEnterKeySearch(e)} />
                <Button icon="pi pi-search" className="p-button-warning" onClick={() => searchByName()} />
              </div>
            </div>
          </div>
          <DataTable className="manageTableHeight" dataKey="companyId" emptyMessage={isSectorLoading ? '' : 'No Sectors Found'} value={sectorData} totalRecords={totalRecords} rows={pageSize} scrollable={true} responsive={true}>
            {dynamicColumns}
          </DataTable>
          <div className="p-col-12 p-0">
            {sectorList && sectorList.length > 0 ? <Paginator first={first} rows={pageSize} scrollable={true} responsive={true} totalRecords={totalRecords} onPageChange={onPageChange}></Paginator> : ''}
          </div>
        </Card>
      </div>
      <Dialog header="Delete Sector" footer={footer} className="custom-header" visible={isDeleteDialogVisible} style={{ width: '30vw' }} modal={true} onHide={() => setIsDeleteDialogVisible(false)}>
        <img src={warning} alt={warning} className="warn-dialog" />
        <div>Deleting this sector will delete all the industries and companies under this particular sector. Do you want to proceed?</div>
      </Dialog>
      <Dialog header="Clear Filters" footer={footerClearFilter} visible={isClearFilterDialogVisible} style={{ width: '50vw' }} modal={true} onHide={() => setIsClearFilterDialogVisible(false)}>
        <div>Filters for all the companies falling within this stock sector will also get cleared. Are you sure you want to clear the filters?</div>
      </Dialog>
    </div>
  )
}
ManageSectorComponent.propTypes = {
  sectorList: PropTypes.array,
  getSectorByPage: PropTypes.func,
  totalRecords: PropTypes.number,
  deleteSector: PropTypes.func,
  clearSectorFilter: PropTypes.func,
  currentPage: PropTypes.number,
  isSectorLoading: PropTypes.bool
}
